'use es6';

import { create } from './strings';
const {
  get
} = create('filters', 'f');
export { get };